export const DEFAULT_PAGE: number = 0;
export const DEFAULT_PAGE_SIZE: number = 50;
export const EMPTY_RESPONSE: unknown = {
  value: [],
  count: 0,
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  hasNextPage: false,
  hasPreviousPage: false,
};
